'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getDragModifierKeys = exports.getDragModifierKeys = function getDragModifierKeys(state) {
  return state.getIn(['app', 'dragModifierKeys']);
};


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/dnd/modifierKeys/dragModifierKeysSelector.js
// module id = 759
// module chunks = 0